import {stringify} from 'qs';
import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {SEARCH_CACHE_MAX_AGE} from '../../utils/constants';

const ACTION_TYPES = {
  NEARBY_CITIES_LOADED: 'NEARBY_CITIES_LOADED',
  NEARBY_CITIES_RESET: 'NEARBY_CITIES_RESET',
};

const namespace = 'cityPage.nearbyCities';

const cityLinksSelector = createSelector(
  (localState = {}) => localState.cityLinks,
  (cityLinks) => cityLinks,
);

const loadNearbyCities = (props) => {
  return (dispatch, getState) => {
    const STATE = getState();
    const cache = true;
    const cacheMaxAge = SEARCH_CACHE_MAX_AGE;
    const {entityId, lat, lng} = props;
    const searchOptions = {
      point: `${lat},${lng}`,
      sort: 'distance asc',
      fieldList: 'id,url,name,ancestors',
      geographyTypeId: 68,
      rows: 30,
      radius: '5000',
      status: 'active',
    };

    const {lang} = STATE;

    return get({
      host: process.env.REACT_APP_API_HOST,
      path: `/search/catalog/geos/v3/?${stringify(searchOptions)}`,
      headers: {
        Authorization: process.env.REACT_APP_API_SECRET,
        'Accept-Language': lang,
      },
      json: true,
      cache,
      cacheMaxAge,
    }).then((body) => {
      const {geos = []} = body;
      const cityLinks = pickNearbyCities(geos, entityId);
      dispatch({type: ACTION_TYPES.NEARBY_CITIES_LOADED, cityLinks});

      return null;
    });
  };
};

const FILTERED_CITIES_COUNT = 20;
const pickNearbyCities = (geos = [], entityId) =>
  geos
    .filter((geo) => (geo.ancestors || []).length >= 3 && parseInt(entityId) !== geo.id)
    .slice(0, FILTERED_CITIES_COUNT);

const resetNearbyCities = () => {
  return (dispatch) => {
    dispatch({type: ACTION_TYPES.NEARBY_CITIES_RESET});
  };
};

const controller = new Controller({
  namespace,
  mapStateToProps(state) {
    const localState = this.getLocalState(state);

    return {
      cityLinks: cityLinksSelector(localState),
    };
  },
  actionCreators: {
    resetNearbyCities,
    loadNearbyCities,
  },
  reducers: [ACTION_TYPES.NEARBY_CITIES_LOADED, ACTION_TYPES.NEARBY_CITIES_RESET],
});

controller.addResetReducer([ACTION_TYPES.NEARBY_CITIES_RESET]);

export default controller;
